// extracted by mini-css-extract-plugin
export var alpha = "_hq-4";
export var alphaInputContainer = "_hq-j";
export var badge = "_hq-b";
export var brandKitGrid = "_hq-l";
export var brandKitItem = "_hq-m";
export var brandKitSwatch = "_hq-n";
export var controls = "_hq-5";
export var formatDropdown = "_hq-h";
export var formatSelector = "_hq-g";
export var hex = "_hq-6";
export var hexInput = "_hq-i";
export var hue = "_hq-3";
export var hueAndAlphaPointer = "_hq-a";
export var percentageLabel = "_hq-k";
export var picker = "_hq-0";
export var rgba = "_hq-8";
export var rgbaSection = "_hq-7";
export var saturation = "_hq-1";
export var saturationPointer = "_hq-9";
export var sliders = "_hq-2";
export var swatch = "_hq-c";
export var swatchDisabled = "_hq-f";
export var swatchRing = "_hq-d";
export var swatchTransparent = "_hq-e";